import { type NextRequest, NextResponse } from "next/server";

export function authMiddleware(request: NextRequest) {
	const token = request.cookies.get("token")?.value;
	const { pathname } = request.nextUrl;

	if (!token && pathname !== "/login") {
		return NextResponse.redirect(new URL("/login", request.url));
	}

	if (token && pathname === "/login") {
		return NextResponse.redirect(new URL("/", request.url));
	}

	return NextResponse.next();
}
